import { environment } from '../environments/environment';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HeaderComponent } from './@theme/components';
import { AngularMaterialModule } from './angular-material.module';
import { GoogleMapModule } from './googlemap.module';
import { CdkDetailRowDirective } from './pages/auth/dashboard/cdk-detail-row.directive';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NotificationService } from './@core/utils/notification.service';
import { ParcelIdPipe } from './@theme/pipes';
import { NonCompletedDialogComponent } from './@theme/components/non-completed-dialog/non-completed-dialog.component';

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  // Pipelines can rebuild the same package version with new translation keys.
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?v=' + encodeURIComponent(environment.appVersion) + '&reload=' + Date.now());
}

@NgModule({
  declarations: [
    HeaderComponent,
    NonCompletedDialogComponent,
    CdkDetailRowDirective,
    ParcelIdPipe
  ],
  entryComponents: [HeaderComponent, NonCompletedDialogComponent],
  exports: [
    AngularMaterialModule,
    CdkDetailRowDirective,
    ParcelIdPipe,
    HeaderComponent,
    RouterModule,
    FlexLayoutModule,
    GoogleMapModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule
  ],
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    AngularMaterialModule,
    GoogleMapModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    DragDropModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [NotificationService],
  bootstrap: [HeaderComponent, NonCompletedDialogComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {}
